var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLocked),expression:"isLocked"}],staticClass:"element-lock-hover"},[_c('div',{staticClass:"lock-inner"},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),(_vm.text)?_c('div',[_c('strong',[_vm._v(_vm._s(_vm.text))])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }